export { default } from './Activities.component';
